import React, { useState, useEffect } from 'react';
import axios from 'axios';
import qs from 'qs';
import { rescueHtml } from '../Components/Tools.js';
import Logo from '../Img/Logo_projets&finances.png';

const Page8Pilotage_Operations = (props) => {
    const blue = '#069BD3';
    const greyChapter = '#DBDBDB';
    const greyclair = '#FAFAFA';
    const green = '#59B44A';
    const red = '#FF0000';
    const fontsize = (props.height*12/890);
    const [pilotage_operation, setPilotage_operation] = useState([]);

    // Fonction pour tronquer le texte
    const truncateText = (text, maxLength) => {
        if (!text) return '-';
        const cleaned = rescueHtml(text);
        return cleaned.length > maxLength ? cleaned.slice(0, maxLength) + '...' : cleaned;
    };

    useEffect(() => {
        loadPilotage();
    }, [props.operation?.id]);

    async function loadPilotage() {
        try {
            const params = {
                'get': true,
                'id_operation': props.operation?.id
            };
            const res = await axios.post('https://app-slfinance.fr/api/pilotage_projet.php', qs.stringify(params));
            if (res.data && Array.isArray(res.data)) {
                setPilotage_operation(res.data);
            }
        } catch (err) {
            console.warn(err);
        }
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: 'white'}}>
            
            {/* Header */}
            <div style={{ display: 'flex', height: '20%' }}>
                <div style={{ flex: 0.6, display: 'flex', marginLeft: 10 }}>
                    {props.logo && (
                        <img style={{ maxHeight: props.height / 8, borderRadius: 5 }} src={props.logo} alt="Logo" />
                    )}
                </div>

                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <p style={{ color: blue, fontSize: (fontsize + 10) }}>Pilotage</p>
                </div>

                <div style={{ flex: 0.6, display: 'flex', justifyContent: 'right', marginRight: 25 }}>
                    <p style={{ color: 'grey', fontSize: (fontsize + 4) }}>{props.operation.nom}</p>
                </div>
            </div>

            {/* Contenu - 60% */}
            <div style={{flex: 1, padding: '10px 15px', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'}}>
                {pilotage_operation.length > 0 ? (
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                        {/* En-têtes du tableau */}
                        <div style={{display: 'flex', marginBottom: 8, paddingBottom: 8, borderBottom: '2px solid #069BD3', backgroundColor: '#f5f5f5', padding: '5px 8px', borderRadius: 3}}>
                            <div style={{marginTop: (0-props.marge), flex: 0.8, minWidth: 60, fontSize: fontsize, fontWeight: 'bold', color: '#069BD3'}}>Date</div>
                            <div style={{marginTop: (0-props.marge), flex: 1, minWidth: 100, fontSize: fontsize, fontWeight: 'bold', color: '#069BD3'}}>Instance</div>
                            <div style={{marginTop: (0-props.marge), flex: 1.5, minWidth: 120, fontSize: fontsize, fontWeight: 'bold', color: '#069BD3'}}>Relevé</div>
                            <div style={{marginTop: (0-props.marge), flex: 1.5, minWidth: 120, fontSize: fontsize, fontWeight: 'bold', color: '#069BD3'}}>Action</div>
                            <div style={{marginTop: (0-props.marge), flex: 0.8, minWidth: 60, fontSize: fontsize, fontWeight: 'bold', color: '#069BD3'}}>Échéance</div>
                            <div style={{marginTop: (0-props.marge), flex: 0.8, minWidth: 80, fontSize: fontsize, fontWeight: 'bold', color: '#069BD3'}}>Responsable</div>
                        </div>

                        {/* Lignes du tableau */}
                        {pilotage_operation.map((line, idx) => {
                            const isCompleted = line[10] == 1;
                            const isLate = line[10] == 0 && (new Date(line[7])) <= (new Date());
                            const bgColor = isCompleted ? '#d4edda' : isLate ? '#f8d7da' : '#ffffff';
                            const borderColor = isCompleted ? '#28a745' : isLate ? '#f5222d' : '#e0e0e0';
                            
                            return (
                                <div key={idx} style={{display: 'flex', marginBottom: 4, padding: '6px 8px', borderLeft: `3px solid ${borderColor}`, backgroundColor: bgColor, borderRadius: 2, alignItems: 'center'}}>
                                    <div style={{marginTop: (0-props.marge), flex: 0.8, minWidth: 60, fontSize: fontsize-1}}>
                                        {line[3] ? line[3].split('-')[2]+'/'+line[3].split('-')[1]+'/'+line[3].split('-')[0] : '-'}
                                    </div>
                                    <div style={{marginTop: (0-props.marge), flex: 1, minWidth: 100, fontSize: fontsize-1}}>
                                        {truncateText(line[4], 20)}
                                    </div>
                                    <div style={{marginTop: (0-props.marge), flex: 1.5, minWidth: 120, fontSize: fontsize-2}}>
                                        {truncateText(line[5], 30)}
                                    </div>
                                    <div style={{marginTop: (0-props.marge), flex: 1.5, minWidth: 120, fontSize: fontsize-2}}>
                                        {truncateText(line[6], 30)}
                                    </div>
                                    <div style={{marginTop: (0-props.marge), flex: 0.8, minWidth: 60, fontSize: fontsize-1, fontWeight: isLate ? 'bold' : 'normal', color: isLate ? red : 'inherit'}}>
                                        {line[7] ? line[7].split('-')[2]+'/'+line[7].split('-')[1]+'/'+line[7].split('-')[0] : '-'}
                                    </div>
                                    <div style={{marginTop: (0-props.marge), flex: 0.8, minWidth: 80, fontSize: fontsize-1}}>
                                        {truncateText(line[8], 20)}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p style={{fontSize: fontsize, color: '#999', textAlign: 'center', marginTop: '20%'}}>Aucun pilotage enregistré</p>
                )}
            </div>

            {/* Footer - 20% */}
            <div style={{padding: '5px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 1, flexShrink: 0}}>
                <div>
                    <p style={{fontSize: fontsize, color: '#666'}}>
                        {props.date}
                    </p>
                </div>
                <p style={{fontSize: fontsize, color: '#8B8B8B'}}>page : {props.pagination} / {props.countPageTotal}</p>
                <div>
                    <img style={{objectFit: 'contain', height: 40, borderRadius: 6}} src={Logo} alt="Logo SF" />
                </div>
            </div>
        </div>
    );
};

export default Page8Pilotage_Operations;
